import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import z from 'zod';
import { TenantCustomer } from '~/tenants/common/TenantPersona';
import { DisplayData } from '~/lib/model';

export const McmCustomerSchema = {
  [FIRST_VERSION_TIMESTAMP]: z.object({
    version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    notes: z.string().optional(),
    crossroads: coerceBoolean().optional(),
    sothebys: coerceBoolean().optional()
  }),
};

export type McmCustomerMetadata = ZodVersionedMetadata<typeof McmCustomerSchema>;

export default class McmCustomer extends TenantCustomer<McmCustomerMetadata> {
  get info(): DisplayData[] {
    const info = super.info;

    if (this.metadata.notes) {
      info.push({ name: 'Notes', value: this.metadata.notes, provider: true });
    }

    return info;
  }
}
